import type { ComponentProps } from 'react';
import styled from 'styled-components';

import type { Rarity } from '#src/__generated__/globalTypes.ts';
import { AnimatedNumber } from '#src/atoms/animations/AnimatedNumber/index.tsx';
import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { Shards } from '#src/atoms/icons/Shards.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { LabelM } from '#src/atoms/typography/index.tsx';
import { isSupportedCardSet } from '#src/lib/cardSets.ts';
import { getRarityShardColor } from '#src/lib/colors.ts';
import { thinMaterial } from '#src/style/utils.tsx';

const Root = styled(Horizontal)`
  ${thinMaterial}
  border-radius: var(--unit);
  padding: var(--half-unit) var(--intermediate-unit);
  background: var(--c-nd-50);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--half-unit);

  & svg {
    width: var(--unit);
    height: var(--unit);
  }
  &button {
    &:hover,
    &:focus {
      background: var(--c-nd-200);
    }
  }
`;

type Props = {
  value: number;
  rarity: Rarity;
  cardSetSlug?: string;
  to?: ComponentProps<typeof ButtonBase>['to'];
};
export const EssenceBalance = ({ value, rarity, cardSetSlug, to }: Props) => {
  const shardColor = getRarityShardColor(
    rarity,
    isSupportedCardSet(cardSetSlug) ? cardSetSlug : null
  );
  return (
    <Root {...(to ? { to, as: ButtonBase } : {})}>
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={value} disableAnimationOnFirstRender />
        </LabelM>
        <Shards color={shardColor} size={2} />
      </Horizontal>
    </Root>
  );
};
